// Admin-only "Dev mode" switch. Persists in localStorage; broadcasts changes so any
// mounted widget (e.g. the Feedback panel) reacts without a reload.
import { useEffect, useState } from 'react';

const KEY = 'dev_mode';
const EVT = 'devmode:change';

export function getDevMode() {
  try { return window.localStorage.getItem(KEY) === 'on'; } catch { return false; }
}
export function setDevMode(on) {
  try { on ? window.localStorage.setItem(KEY, 'on') : window.localStorage.removeItem(KEY); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVT, { detail: !!on }));
}
export function useDevMode() {
  const [on, setOn] = useState(getDevMode());
  useEffect(() => {
    const h = () => setOn(getDevMode());
    window.addEventListener(EVT, h);
    window.addEventListener('storage', h);       // sync across tabs
    return () => { window.removeEventListener(EVT, h); window.removeEventListener('storage', h); };
  }, []);
  return on;
}

// Central-service base: '' = same origin (dev, via setupProxy). In prod, set
// REACT_APP_FEEDBACK_BASE to the dev-box HTTPS URL so prod feedback reaches the same store.
export const FEEDBACK_BASE = process.env.REACT_APP_FEEDBACK_BASE || '';
